import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 md:py-20" data-id="element-33" data-mp="3ogau3n1a2v3q">
      <div className="mx-auto max-w-3xl text-center" data-id="element-34" data-mp="3oi41x5nmnldb">
        <h2 className="font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-35" data-mp="3sgbgpuyj6clv">
          From a dentist who second-guesses every anterior case…
        </h2>
        <p className="mt-4 font-display text-[20px] italic leading-snug text-gold-deep sm:text-2xl" data-id="element-36" data-mp="3jh6mv1xwz7g1">
          …to a clinician with a system that guides the planning process.
        </p>
      </div>

      <div className="mx-auto mt-10 grid max-w-4xl gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-37" data-mp="39qby9qx73vrf">
        <div className="rounded-3xl border border-ink/10 bg-white p-5 sm:p-6" data-id="element-38" data-mp="2vr3uslu021hf">
          <p className="flex items-center gap-2 text-[12px] font-extrabold uppercase tracking-[0.14em] text-alert" data-id="element-39" data-mp="2vt6trvd4r4ya">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-40" data-mp="x4k26vwc7q4p" />
            Before
          </p>
          <ul className="mt-5 space-y-4" data-id="element-41" data-mp="x6emq93p5g89">
            {beforeItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-snug text-clay" data-id="element-42" data-mp="t51ho18fhh2e">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-43" data-mp="171yh2r2m46uw" />
                <span data-id="element-44" data-mp="1246jbgfadqis">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border border-gold/40 bg-ink p-5 sm:p-6" data-id="element-45" data-mp="eeluigwgbz1l">
          <p className="flex items-center gap-2 text-[12px] font-extrabold uppercase tracking-[0.14em] text-gold-light" data-id="element-46" data-mp="9g0t4e5gr9bk">
            <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="o5ghxolfp4om" />
            With Resin Architect™
          </p>
          <ul className="mt-5 space-y-4" data-id="element-48" data-mp="jbucohhlo32u">
            {afterItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-snug text-cream/90" data-id="element-49" data-mp="3rre6piq3hpiy">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" aria-hidden="true" data-id="element-50" data-mp="3mt2s6uouuque" />
                <span data-id="element-51" data-mp="1qq7wzkddvdyi">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-52" data-mp="1vo9fo46wdb9g">
        <CtaButton label="I want to plan with Resin Architect™" data-id="element-53" data-mp="20gsut5l8gegd" />
      </div>
    </section>;
}